export const cTInt = (s?: string | null) => {
  if (!s) return undefined;
  const v = parseInt(s.replace(/,/g, ""));
  return isNaN(v) ? undefined : v;
}
export const cTFloat = (s?: string | null) => {
  if (!s) return undefined;
  const v = parseFloat(s.replace(/,/g, ""));
  return isNaN(v) ? undefined : v;
}